import type {ProLayoutProps} from '@ant-design/pro-components'

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean
  logo?: string
} = {
  "navTheme": "light",
  "colorPrimary": "#e97451",
  "layout": "top",
  "contentWidth": "Fixed",
  "fixedHeader": true,
  "fixSiderbar": false,
  title: '启星代码生成器',
  "pwa": true,
  "logo": "/logo.svg",
  token: {
    header: {
      colorBgHeader: '#faf9f5',
      colorHeaderTitle: '#2e2c28',
      colorTextMenu: '#5f5d57',
      colorTextMenuSelected: '#e97451',
      colorBgMenuItemSelected: 'transparent'
    },
    pageContainer: {
      paddingInlinePageContainerContent: 0,
      paddingBlockPageContainerContent: 0,
      colorBgPageContainer: '#faf9f5'
    },
    bgLayout: '#faf9f5',
    colorBgContainer: '#ffffff',
    colorTextBase: '#2e2c28',
    colorBorder: '#e8e6e0'
  },
  "splitMenus": false,
  "siderMenuType": "sub"
}

export default Settings
